import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appHelpContent]',
})
export class HelpContentDirective implements OnInit {
    @Input('helpContent') helpContent;

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    ngOnInit() {
        this.renderer.setAttribute(
            this.elementRef.nativeElement,
            'data-help-content',
            this.helpContent
        );
    }
}
